import { App } from "antd";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  checkEmail,
  registerEmailPassword,
  sendEmail,
  setStepRegister,
  verifyEmail,
} from "store/user/auth/user_auth.action";
import { registerSelector } from "store/user/auth/user_auth.selector";
import { firebaseLoginWithGoogle } from "store/user/login/login.action";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
export const useSignUp = () => {
  // -------------------------- VAR -----------------------------
  const navigate = useNavigate();
  const { message } = App?.useApp();
  // -------------------------- STATE ---------------------------
  const [loading, setLoading] = useState(false);
  const [checking, setChecking] = useState(false);
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const register = useSelector(registerSelector);
  // -------------------------- FUNCTION ------------------------

  // bước nhập thông tin.
  const handleSentMail = ({ values }) => {
    setLoading(true);
    if (!values) return message.error("Làm ơn điền email, password!");
    const register = values;
    dispatch(
      checkEmail({ register }, (res) => {
        if (res?.status === 200) {
          const email = register?.email;
          sendEmailAndNext(email);
        }
        if (res?.status === 500) {
          message.error(res?.data);
        }
      }),
    );
  };

  const sendEmailAndNext = (email) => {
    dispatch(
      sendEmail({ email }, (response) => {
        setLoading(false);
        if (response?.status === 200) {
          dispatch(setStepRegister(1));
        }
        if (response?.status === 500) {
          const error = response.data;
          message.error(error);
        }
      }),
    );
  };

  // dành cho bước verify code.
  const onChangeCode = (pincode) => {
    const max = 6;
    if (pincode?.length === max) {
      onFinish(pincode);
    }
  };

  const onFinish = (pincode) => {
    if (!register) return message.error("Thông tin đăng ký không tìm thấy !");
    setChecking(true);
    const email = register?.email;
    dispatch(
      // register
      verifyEmail({ email, pincode }, (response) => {
        if (response?.status === 200) {
          dispatch(
            registerEmailPassword({ register }, (res) => {
              if (res?.status === 200) {
                setChecking(false);
                dispatch(setStepRegister(0));
                message.success(
                  "Đăng ký thành công, xin vui lòng đăng nhập vào nền tảng",
                );
              } else {
                setChecking(false);
                const code = res.data;
                message.error(code);
              }
            }),
          );
        }
        if (response?.status === 500) {
          setChecking(false);
          const error = response.data;
          message.error(error);
        }
      }),
    );
  };

  // gửi lại mã code khác.
  // eslint-disable-next-line no-undef
  const onGetCode = ({ disabled, setLoading = () => {} }) => {
    if (!register) return message.error("Làm ơn điền thông tin đăng ký");
    if (disabled) return;

    const email = register?.email;
    setLoading(true);
    dispatch(
      sendEmail({ email }, (response) => {
        setLoading(false);
        if (response?.status === 200) {
          const text = "Gửi mã thành công";
          message.success(text);
        }
        if (response?.status === 500) {
          const error = response.data;
          message.error(error);
        }
      }),
    );
  };

  // đăng nhập với login.
  const handleLoginWithGoogle = () => {
    setLoading(true);
    dispatch(
      firebaseLoginWithGoogle((res) => {
        if (res?.status === 200) {
          message.success("Đăng nhập thành công");
        }
        if (res?.status === 500) {
          setLoading(false);
          message.error(res?.data);
        }
      }),
    );
  };

  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return {
    loading,
    handleSentMail,
    checking,
    onChangeCode,
    handleLoginWithGoogle,
    onGetCode,
  };
};
